import React from 'react'
import PropTypes from 'prop-types'
import styles from './_privacyStyles.css'

function Title (props) {
  const { children } = props

  return (
    <h2 className={styles.title}>
      { children }
    </h2>
  )
}

Title.propTypes = {
  children: PropTypes.object,
}

export default Title



// WEBPACK FOOTER //
// ./src/components/privacy_center/util/Title.jsx